/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Included_1Inputs */

const tr_landing_pricing_included_1 = /** @type {(inputs: Landing_Pricing_Included_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KVKK uyumlu`)
};

const en_landing_pricing_included_1 = /** @type {(inputs: Landing_Pricing_Included_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KVKK compliant`)
};

const de_landing_pricing_included_1 = /** @type {(inputs: Landing_Pricing_Included_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KVKK-konform`)
};

const ru_landing_pricing_included_1 = /** @type {(inputs: Landing_Pricing_Included_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Соответствие KVKK`)
};

/**
* | output |
* | --- |
* | "KVKK compliant" |
*
* @param {Landing_Pricing_Included_1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricing_included_1 = /** @type {((inputs?: Landing_Pricing_Included_1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Included_1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_included_1(inputs)
	if (locale === "de") return de_landing_pricing_included_1(inputs)
	if (locale === "ru") return ru_landing_pricing_included_1(inputs)
	return tr_landing_pricing_included_1(inputs)
});